import React, { useState, useEffect } from 'react';
import IconBack from '../../assets/Images/icons/icon-back';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Select, Table } from 'antd';
import CookieScannerService from '../../services/CookieScanner.service';
import useNotify from '../../context/Notification/useNotify';
const { Option } = Select;

export default function ReportTable() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { domainId, categories } = useParams();
    const [cookieInfo, setCookieInfo] = useState();
    const [cookieCategoryList, setCookieCategoryList] = useState([]);
    const notify = useNotify();

    const columns = [
        {
            title: t('COOKIE.CookieName'),
            dataIndex: 'cookieName',
            key: 'cookieName',
            width: '12%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.Provider'),
            dataIndex: 'provider',
            key: 'provider',
            width: '10%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.DomainURL'),
            dataIndex: 'domainUrl',
            key: 'domainUrl',
            width: '20%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('Type'),
            dataIndex: 'type',
            key: 'type',
            width: '10%',
            sorter: true,
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.Expiry'),
            dataIndex: 'expiry',
            key: 'expiry',
            width: '13%',
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.CookiePurpose'),
            dataIndex: 'cookiePurpose',
            key: 'cookiePurpose',
            width: '20%',
            render: (value, row, index) => {
                return <>{value || '-'}</>;
            },
        },
        {
            title: t('COOKIE.CookieCategory'),
            dataIndex: 'cookieCategoryId',
            key: 'cookieCategoryId',
            width: '15%',
            render: (value, row, index) => {
                return (
                    <>
                        {value === 'Unclassified' ? (
                            <>
                                <Select
                                    className="w-full"
                                    onChange={(e) => handleChange(e, index)}
                                    placeholder="Select category"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {cookieCategoryList?.map((e) => (
                                        <>
                                            <Option value={e.cookieCategoryId}>
                                                {e.cookieCategoryName}
                                            </Option>
                                        </>
                                    ))}
                                    {/* <Option value="Necessary">Necessary</Option>
                                    <Option value="Analytics">Analytics</Option>
                                    <Option value="Marketing">Marketing</Option> */}
                                </Select>
                            </>
                        ) : (
                            <>
                                <Select
                                    defaultValue={value}
                                    className="w-full"
                                    onChange={(e) => handleChange(e, index)}
                                    placeholder={t('COOKIE.SelectCategory')}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.children ?? '')
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                    }
                                >
                                    {cookieCategoryList?.map((e) => (
                                        <>
                                            <Option value={e.cookieCategoryId}>
                                                {e.cookieCategoryName}
                                            </Option>
                                        </>
                                    ))}
                                    {/* <Option value="Necessary">Necessary</Option>
                            <Option value="Analytics">Analytics</Option>
                            <Option value="Marketing">Marketing</Option> */}
                                </Select>
                            </>
                        )}
                    </>
                );
            },
        },
    ];

    const handleChange = async (value, index) => {
        const payload = {
            cookieId: cookieInfo?.cookieList[index].cookieId,
            cookieCategoryId: value,
        };
        console.log(payload);
        try {
            const { data } = await CookieScannerService.updateCategory(payload);
            if (data?.resultCode === 1) {
                // getReportList();
                // console.log()
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };
    const getReportList = async () => {
        let ObjectSearch = {};
        ObjectSearch = {
            domainId: domainId,
            cookieCategory: categories,
            s: 'cookieName',
            sd: 'ASC',
        };
        try {
            const { data } = await CookieScannerService.getReportList(
                ObjectSearch
            );
            // const item = data?.resultData
            if (data?.resultData) {
                setCookieInfo(data?.resultData);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        const getCookieCategory = async () => {
            try {
                const { data } = await CookieScannerService.getCookieCategory(
                    domainId
                );
                if (data?.resultData) {
                    setCookieCategoryList(data?.resultData);
                }
            } catch (err) {
                console.log(err);
            }
        };
        getCookieCategory();
        getReportList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    <IconBack />
                </div>
                <span>{cookieInfo?.cookieCategory || 'Unclassified'}</span>
            </div>
            <div className="sub-title mb-2">
                <span className="text-sm text-gray-400">
                    {t('Cookie Management')} / {t('common.CookieScanner')} /{' '}
                </span>
                <span>{cookieInfo?.cookieCategory || 'Unclassified'}</span>
            </div>
            <div className="grid grid-cols-12 bg-white rounded-md flex items-center p-4">
                <div className="col-span-12 text-purple text-xl font-semibold">
                    {cookieInfo?.cookieCategory || 'Unclassified'} (
                    {cookieInfo?.count})
                </div>
                <div
                    className="col-span-12"
                    style={{ borderBottom: '3px solid #F4F6FC;' }}
                >
                    {cookieInfo?.cookieDetail || '-'}
                </div>
                <div className="col-span-12 mt-6 mb-10">
                    <Table
                        className="inbox_table"
                        dataSource={cookieInfo?.cookieList}
                        columns={columns}
                        pagination={false}
                    />
                </div>
            </div>
        </>
    );
}
